import { createSlice } from "@reduxjs/toolkit";
import { getIsCheckApplicationSubmittedThunk } from "./services/thunk/DetailsThunk";

const initialState = {
  isApplicationSubmitted: false,
  loading: false,
  error: null,
};

const applicationSubmittedSlice = createSlice({
  name: "applicationSubmitted",
  initialState,
  reducers: {
    resetApplicationSubmitted(state) {
      state.isApplicationSubmitted = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIsCheckApplicationSubmittedThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getIsCheckApplicationSubmittedThunk.fulfilled,
        (state, action) => {
          state.loading = false;
          state.isApplicationSubmitted =
            action.payload?.data?.isApplicationSubmitted;
        }
      )
      .addCase(
        getIsCheckApplicationSubmittedThunk.rejected,
        (state, action) => {
          state.loading = false;
          state.isApplicationSubmitted = false;
          //state.error = action.payload || action.error.message;
        }
      );
  },
});

export const { resetApplicationSubmitted } = applicationSubmittedSlice.actions;

export default applicationSubmittedSlice.reducer;
